<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 570.3 570.3" v-bind:ref="'logo'" v-bind:svg-inline="''" v-bind:class="'app-logo'" @mouseenter="onMouseenter" @mouseleave="onMouseleave" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path data-id="apostrophe" d="M305.2 131.3c0-3 .5-6.1 1.6-8.9 1-2.6 2.5-5 4.4-7 1.9-2 4.2-3.5 6.8-4.5 2.7-1.1 5.6-1.6 8.6-1.6 6 0 10.9 1.9 14.5 5.7 3.7 3.8 5.5 9 5.5 15.7-.1 6.7-1.7 13.3-4.7 19.2-3.2 6.7-7.1 12.9-11.6 18.7-4.4 5.7-9.2 10.9-14.5 15.7-4 3.7-8.4 7.1-13.1 10-3.7 2.1-7 3.2-10 3.2-2 .1-3.9-.4-5.5-1.6-1.4-1.2-2.1-3-1.9-4.9 0-2.3 1-4.4 2.6-6 1.7-1.8 4-4.2 6.8-7 3.4-3.5 6.5-7.2 9.3-11.1 4.1-5.7 7.5-11.8 10.3-18.3a17.3 17.3 0 01-6.3-6.3c-2-3.2-3-7.1-2.8-11z" fill="#c1272d"/><path data-id="i" d="M268.9 247.8c0 3.7-1.8 5.5-5.5 5.5H139.1c-3.7 0-5.5-1.8-5.5-5.5v-13.5c0-3.5 1.8-5.3 5.5-5.3h43.4c3.5 0 5.3-1.8 5.3-5.5v-75.9c0-3.5-1.8-5.3-5.3-5.3h-43.4c-3.7 0-5.5-1.8-5.5-5.5v-13.3c0-3.6 1.8-5.5 5.5-5.5h124.3c3.7 0 5.5 1.8 5.5 5.5v13.3c0 3.6-1.8 5.5-5.5 5.5h-43.3c-3.5 0-5.3 1.8-5.3 5.3v75.9c0 3.7 1.8 5.5 5.3 5.5h43.3c3.7 0 5.5 1.8 5.5 5.3v13.5z"/><path data-id="a" d="M270.7 399.4c.2 10.4-4.1 20.3-11.7 27.2-7.8 7.3-17.4 10.9-28.7 10.9h-53.9c-10.7.2-21.1-4.1-28.6-11.7-7.7-7.4-12-17.6-11.8-28.3 0-22.3 18.1-40.4 40.4-40.4h62.8c3 0 4.5-1.5 4.5-4.5v-10.4c.1-4-1.4-7.9-4-11-2.3-2.9-5.8-4.7-9.5-4.7h-33.6c-1.7 0-3.4-.8-4.6-2-1.3-1.1-2.1-2.8-2.1-4.5v-11c.5-3.5 3.2-6.2 6.7-6.7h33.7c22.3.1 40.3 18.1 40.4 40.4v56.7zm-26.9 0v-13.1c0-3-1.5-4.5-4.5-4.5h-62.9c-3.7 0-7.2 1.7-9.5 4.6-5.3 6.4-5.3 15.7 0 22.1 2.3 2.9 5.8 4.7 9.5 4.7h53.9c3.6.1 7-1.3 9.6-3.8 2.7-2.6 4.1-6.2 3.9-10z"/><path data-id="m" d="M438.2 432c0 3.7-1.8 5.5-5.3 5.5h-16.3c-3.5 0-5.3-1.8-5.3-5.5v-92.4c.1-4.1-1.3-8-4-11.1-2.3-2.9-5.8-4.6-9.5-4.6-3.8 0-7.3 1.7-9.7 4.6-2.7 3.1-4.1 7-4 11.1V378c0 3.7-1.8 5.5-5.3 5.5h-16.3c-3.5 0-5.3-1.8-5.3-5.5v-38.4c.1-4.1-1.3-8-4-11.1-2.4-2.9-5.9-4.6-9.7-4.6-3.7 0-7.2 1.7-9.5 4.6-2.7 3.1-4.1 7-4 11.1V432c0 3.7-1.8 5.5-5.3 5.5h-16.3c-3.5 0-5.3-1.8-5.3-5.5v-92.4c-.2-10.7 4.1-20.9 11.8-28.3 7.5-7.7 17.8-11.9 28.6-11.7 10-.1 19.7 3.5 27.1 10.2 7.4-6.7 17.1-10.3 27.1-10.2 10.7-.2 21.1 4.1 28.6 11.7 7.7 7.4 12 17.6 11.8 28.3V432z"/><path fill="none" stroke="#000" stroke-width="25.16" stroke-linejoin="round" d="M12.6 12.6h545.1v545.1H12.6z"/></svg>
</template>

<script lang="ts">
import gsap, { Power3, Power4 } from 'gsap';
import { defineComponent } from 'vue';

type TimelineKeypoints = [gsap.TweenVars] | [gsap.TweenVars, string | number | undefined];

const framesToMs = (frames: number, fps = 60): number => frames / fps;

export default defineComponent({
	props: {
		hover: {
			type: Boolean,
		},
		shuffle: {
			type: Boolean,
		},
	},

	data() {
		return {
			hoverTimelineEnter: null as gsap.core.Timeline | null,
			hoverTimelineLeave: null as gsap.core.Timeline | null,
			shuffleTimeline: null as gsap.core.Timeline | null,
		};
	},

	watch: {
		shuffle(shuffle) {
			if (shuffle) {
				this.shuffleTimeline?.repeat(-1).play(0);
			} else {
				this.shuffleTimeline?.repeat(0);
			}
		},
	},

	mounted() {
		this.cleanupElements();

		if (this.shuffle) {
			this.initShuffleAnimation();
		}
		this.initHoverAnimation();
	},

	beforeUnmount() {
		this.shuffleTimeline?.kill();
		this.hoverTimelineEnter?.kill();
		this.hoverTimelineLeave?.kill();
	},

	methods: {
		getLogo() {
			return this.$refs.logo as SVGElement | null;
		},

		getLogoElements() {
			const logo = this.getLogo();

			if (!logo) {
				return null;
			}

			const ids = ['i', 'a', 'm', 'apostrophe'] as const;

			return ids.reduce(
				(acc, id) => {
					acc[id] = logo.querySelector(`[data-id="${id}"]`)!;

					return acc;
				},
				{} as Record<(typeof ids)[number], Element>,
			);
		},

		initShuffleAnimation() {
			const elements = this.getLogoElements();

			if (!elements) {
				return;
			}

			const { a, i, m, apostrophe } = elements;
			const duration = framesToMs(12);
			const defaultPosition = `>${framesToMs(14)}`;
			const defaults: gsap.TweenVars = { ease: Power4.easeOut, duration };
			const mainTimeline = gsap.timeline({ defaults, paused: true, repeat: -1, repeatDelay: 0.5 });
			const outOffset = 45;
			const move = {
				vertical: 185,
				horizontal: 170,
			};

			mainTimeline.add(
				this.makeTimeline(i, defaults, [
					[{ translateX: -outOffset, translateY: -outOffset, ease: Power4.easeIn }],

					[{ translateX: move.horizontal }, `>${framesToMs(17)}`],
					[{ translateY: move.vertical + outOffset }, defaultPosition],
					[{ translateX: -outOffset }, defaultPosition],
					[{ translateY: -outOffset }, defaultPosition],

					[{ translateX: 0, translateY: 0 }, `>${framesToMs(16)}`],
				]),
				`0`,
			);
			mainTimeline.add(
				this.makeTimeline(apostrophe, defaults, [
					[{ translateX: -outOffset, translateY: -outOffset, ease: Power4.easeIn }],

					[{ translateX: move.horizontal }, `>${framesToMs(13)}`],
					[{ translateY: move.vertical + outOffset }, `>${framesToMs(20)}`],
					[{ translateX: -outOffset }, defaultPosition],
					[{ translateY: -outOffset }, defaultPosition],

					[{ translateX: 0, translateY: 0 }, `>${framesToMs(14)}`],
				]),
				`${framesToMs(1)}`,
			);
			mainTimeline.add(
				this.makeTimeline(a, defaults, [
					[{ translateX: -outOffset, translateY: outOffset, ease: Power4.easeIn }],

					[{ translateY: -move.vertical - outOffset }, `>${framesToMs(18)}`],
					[{ translateX: move.horizontal + outOffset }, `>${framesToMs(17)}`],
					[{ translateY: outOffset }, defaultPosition],
					[{ translateX: -outOffset }, defaultPosition],

					[{ translateX: 0, translateY: 0 }, `>${framesToMs(10)}`],
				]),
				`${framesToMs(2)}`,
			);
			mainTimeline.add(
				this.makeTimeline(m, defaults, [
					[{ translateX: outOffset, translateY: outOffset, ease: Power4.easeIn }],

					[{ translateX: -move.horizontal - outOffset }, `>${framesToMs(20)}`],
					[{ translateY: -move.vertical - outOffset }, `>${framesToMs(17)}`],
					[{ translateX: outOffset }, defaultPosition],
					[{ translateY: outOffset }, defaultPosition],

					[{ translateX: 0, translateY: 0 }, `>${framesToMs(8)}`],
				]),
				`${framesToMs(3)}`,
			);

			this.shuffleTimeline = mainTimeline;
			if (this.shuffle) {
				setTimeout(() => {
					this.shuffleTimeline?.play();
				}, 200);
			}
		},

		initHoverAnimation() {
			const elements = this.getLogoElements();

			if (!elements) {
				return;
			}

			const { a, apostrophe, i, m } = elements;
			const defaults: gsap.TweenVars = { ease: Power3.easeOut };
			const enterTimeline = gsap.timeline({ defaults, paused: true });
			const IN_OFFSET = 10;
			const OUT_OFFSET = 30;

			enterTimeline.add(
				this.makeTimeline(i, defaults, [
					[{ translateX: IN_OFFSET, translateY: IN_OFFSET, duration: framesToMs(1) }],
					[{ translateX: -OUT_OFFSET, translateY: -OUT_OFFSET, duration: framesToMs(13) }],
				]),
				'0',
			);
			enterTimeline.add(
				this.makeTimeline(apostrophe, defaults, [
					[{ translateX: -IN_OFFSET, translateY: IN_OFFSET, duration: framesToMs(1) }],
					[{ translateX: OUT_OFFSET, translateY: -OUT_OFFSET, duration: framesToMs(12) }],
				]),
				'0',
			);
			enterTimeline.add(
				this.makeTimeline(a, defaults, [
					[{ translateX: IN_OFFSET, translateY: -IN_OFFSET, duration: framesToMs(1) }],
					[{ translateX: -OUT_OFFSET, translateY: OUT_OFFSET, duration: framesToMs(14) }],
				]),
				'0',
			);
			enterTimeline.add(
				this.makeTimeline(m, defaults, [
					[{ translateX: -IN_OFFSET, translateY: -IN_OFFSET, duration: framesToMs(1) }],
					[{ translateX: OUT_OFFSET, translateY: OUT_OFFSET, duration: framesToMs(15) }],
				]),
				'0',
			);

			const leaveTimeline = gsap.timeline({ defaults, paused: true });

			leaveTimeline.add(
				this.makeTimeline(i, defaults, [
					[{ translateX: 0, translateY: 0, duration: framesToMs(12) }],
				]),
				'0',
			);
			leaveTimeline.add(
				this.makeTimeline(apostrophe, defaults, [
					[{ translateX: 0, translateY: 0, duration: framesToMs(12) }],
				]),
				`${framesToMs(1)}`,
			);
			leaveTimeline.add(
				this.makeTimeline(a, defaults, [
					[{ translateX: 0, translateY: 0, duration: framesToMs(12) }],
				]),
				`${framesToMs(2)}`,
			);
			leaveTimeline.add(
				this.makeTimeline(m, defaults, [
					[{ translateX: 0, translateY: 0, duration: framesToMs(12) }],
				]),
				`${framesToMs(3)}`,
			);

			this.hoverTimelineEnter = enterTimeline;
			this.hoverTimelineLeave = leaveTimeline;
		},

		makeTimeline(el: Element, defaults: gsap.TweenVars = {}, keyPoints: TimelineKeypoints[]) {
			const timeline = gsap.timeline({ defaults });

			for (const [vars, position] of keyPoints) {
				timeline.to(el, vars, position);
			}

			return timeline;
		},

		onMouseenter() {
			if (this.shuffle) {
				return;
			}

			if (this.hover) {
				this.hoverTimelineEnter?.play(0);
			}
		},

		onMouseleave() {
			if (this.shuffle) {
				return;
			}

			if (this.hover) {
				this.hoverTimelineLeave?.play(0);
			}
		},

		cleanupElements() {
			// for some reason, new logo copies current state of other running animation so we need to do clean up :shrug:
			const elements = this.getLogoElements();

			if (!elements) {
				return;
			}

			for (const el of Object.values(elements)) {
				el.removeAttribute('transform');
				el.removeAttribute('style');
			}
		},
	},
});
</script>
